
/**
 * 강의 콘텐츠 유형
 */
export type UpdateCourseDraft200SectionsItemLecturesItemContentType = typeof UpdateCourseDraft200SectionsItemLecturesItemContentType[keyof typeof UpdateCourseDraft200SectionsItemLecturesItemContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateCourseDraft200SectionsItemLecturesItemContentType = {
  VIDEO: 'VIDEO',
  MARKDOWN: 'MARKDOWN',
  VIDEO_MARKDOWN: 'VIDEO_MARKDOWN',
  QUIZ: 'QUIZ',
  EXTERNAL_LINK: 'EXTERNAL_LINK',
  TEXT: 'TEXT',
  CODING: 'CODING',
} as const;
